import { Style } from '@/components/style';
import { img } from '@/assets';
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Area from '@/utils/area';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import StoreUtils from '@/utils/storeInfoUtils';
import { isEmpty } from 'lodash';
import { ReactComponent as ArrowDown } from '@/assets/img/arrow_down_black.svg';
import { ReactComponent as Earth } from '@/assets/img/earth_black.svg';

const { alertColor, blackColor, primaryColor, gray3Color } =
  new Style().getUiConfig();

function LocaleDropDownMenu({ locale, setLocale, webStoreVo }) {
  const location = useLocation();
  const history = useHistory();
  const [currentSelectedStoreLocale, setCurrentSelectedStoreLocale] =
    useState<any>();
  const [storeLocales, setStoreLocales] = useState<any[]>([]);
  const welcomeLocale: string | null = new URLSearchParams(location.search).get(
    'welcomeLocale'
  );

  useEffect(() => {
    if (webStoreVo?.langs?.length > 0) {
      const allLangs = webStoreVo.langs;
      const areaCodeList = Area.getAreaCodesListByLangs(allLangs);
      const storeLocale = Area.getLocaleListByLangs(allLangs);
      const defaultLocale = Object.keys(storeLocale[0])[0]; // ex : zh-TW
      const defaultStoreLocale = storeLocale[0][Object.keys(storeLocale[0])[0]];
      const defaultAreaCode = areaCodeList[0];
      setStoreLocales(storeLocale);
      if (locale) {
        const findCurrentStoreLocale = storeLocale.find(
          (sl) => Object.keys(sl)[0] === locale
        );
        if (findCurrentStoreLocale) {
          if (welcomeLocale === null) {
            const queryParams = new URLSearchParams(location.search);
            queryParams.set('welcomeLocale', String(defaultLocale));
            setLocale(defaultLocale);
            history.push({
              pathname: location.pathname,
              search: `${queryParams}`,
            });
          } else if (Area.checkAreaCodeExist(welcomeLocale)) {
            setLocale(welcomeLocale);
          }
          setCurrentSelectedStoreLocale(findCurrentStoreLocale[locale]);
        } else {
          setLocale(defaultLocale);
          setCurrentSelectedStoreLocale(defaultStoreLocale);
        }
      } else {
        setLocale(defaultLocale);
        setCurrentSelectedStoreLocale(defaultStoreLocale);
      }

      //   setSelectedAreaCode(defaultAreaCode);
      //   setAreaCodes(areaCodeList);
    }
  }, [webStoreVo]);

  return (
    <div>
      <div className="text-center">
        <div className="dropdown">
          <button
            style={{
              width: '225px',
              height: '44px',
              fontSize: '16px',
              backgroundColor: '#F3F3F4',
              border: '0px',
            }}
            className="btn btn-lg"
            type="button"
            data-testid="localeDropDownMenu"
            id="localeDropDownMenu"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div className="d-flex align-items-center justify-content-between">
              <div />
              <div className="d-flex align-items-center">
                <Earth style={{ marginRight: '8px' }} />
                {currentSelectedStoreLocale
                  ? currentSelectedStoreLocale.display
                  : ''}
              </div>

              <ArrowDown />
            </div>
          </button>
          <ul
            style={{ width: '225px', border: '1px solid #8D8C8C' }}
            className="dropdown-menu"
            aria-labelledby="localeDropDownMenu"
          >
            {storeLocales.map((storeLocale, i) => {
              const key = Object.keys(storeLocale)[0];
              const { display } = storeLocale[key];
              return (
                <li key={i} className="div-hover">
                  <div
                    style={{
                      textAlign: 'center',
                      padding: '11px 15px',
                      minWidth: '100px',
                      fontSize: '16px',
                    }}
                    className="text-center"
                    onClick={() => {
                      setLocale(key);
                      const queryParams = new URLSearchParams(location.search);
                      queryParams.set('welcomeLocale', String(key));

                      history.push({
                        pathname: location.pathname,
                        search: `${queryParams}`,
                      });
                    }}
                  >
                    {display}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}

LocaleDropDownMenu.defaultProps = {};

LocaleDropDownMenu.propTypes = {
  locale: PropTypes.string.isRequired,
  setLocale: PropTypes.func.isRequired,
  webStoreVo: PropTypes.shape({}).isRequired,
};

export default LocaleDropDownMenu;
